// src/terms.ts
export const termsAndConditions = `
  Terms and Conditions:

  1. Payments are authorized at booking and captured 24 hours before showtime.
  2. If the screening is cancelled before capture, no charge is taken.
  3. If you cancel a booking, 50% of the total is retained.
     - If you cancel before capture, we capture 50% as a cancellation fee.
     - If you cancel after capture, we refund 50%.
  4. Cancellations made less than 24 hours before the show are not eligible for a refund.
  5. By booking, you agree to these terms and conditions.
`;
